import { render, staticRenderFns } from "./ImpairmentInfo.vue?vue&type=template&id=2fe09d23&scoped=true"
import script from "./ImpairmentInfo.vue?vue&type=script&lang=js"
export * from "./ImpairmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe09d23",
  null
  
)

export default component.exports